<template>
  <div class="hello">
    <div class="id" style="background: #37D541;">
      <img  class="ad" src="../assets/ad.png">
      <img  class="ad" src="../assets/ad1.png">
      <img  class="ad" src="../assets/ad2.png">
      <img  class="ad" src="../assets/ad3.png">
      <img  class="ad" src="../assets/ad4.png">
    </div>
    <!-- <div class="box_1">
      <div style="width: 190px;padding: 59px 0 0 331px;">
        <div class="text-wrapper_1">
          <div class="text_1">{{this.content.price}}</div> <div class="text_2">元</div>
        </div>
        <div class="tag_1"><span class="text_3">{{this.content.price==899?'365':this.content.price==99?'30':'5'}}天体验期</span></div>
      </div>
      <div class="goBack" @click.stop="handleDialog">
          <div class="go">GO</div>
          <div class="gojiantou">&gt;&gt;&gt;</div>
      </div>
    </div> -->
    <div class="dialogBox" v-if="dialogVisible" @touchmove.prevent >
      <div class="payBox" ref="payBox">
        <div class="content">
          <div class="close">
            <img src="../assets/x.png" class="x"  alt="" @click.stop="closeDialog">
          </div>
          <div class="contentBox1">
            <img src="../assets/restTime.png">
            <div id="hour" class="time">
              {{house}}
            </div>
            <b>:</b>
            <div id="minute" class="time">
              {{min}}
            </div>
            <b>:</b>
            <div id="second" class="time">
              {{send}}
            </div>
          </div>
          <div class="contentBox2">
            <div class="contentBox-title">订单内容</div>
            <div class="contentBox2-body">
              <div>
                <p style="margin-bottom: 11px;font-weight:700;font-family:SourceHanSansSC-Medium">易古筝智能陪练{{this.content.price==899?'365':this.content.price==99?'30':'5'}}天无限体验</p>
                <p style="font-size: 24px;font-family:SourceHanSansSC-Regular">弹奏打分 海量曲谱 练琴报告</p>
              </div>
              <div style="font-size: 30px;font-family:SourceHanSansSC-Medium">¥{{this.content.price}}</div>
            </div>
            <!-- <img src="../assets/orderContent.png"> -->
          </div>
          <div class="contentBox3" ref="inputShow">
            <div class="contentBox-title" style="padding:31px 0 12px 21px">练琴账号</div>
            <div>
              <input type="text"  class="input" placeholder="请输⼊⼿机号（仅作为体验凭证）" maxlength="11"  v-model="phone" @focus="focus" @blur="changeBlur">
            </div>
            <div style="position:relative">
              <input type="text"   autocomplete="off" class="input" placeholder="请输入验证码" maxlength="6" v-model="code" @focus="focus" @blur="changeBlur">  
              <div v-if="downtime"  @click="getCode"  class="getCode" >点击获取验证码</div>
              <!-- @input="changeInput" -->
              <div v-if="!downtime" class="getCode" >
                 <!-- <van-count-down @finish="finish" format="ss" style="font-size:33px;color:#FF3700" :time="times" /> -->
                 <van-count-down  @finish="finish" :time="times">
                  <template #default="timeData">
                    <span class="block">{{ timeData.seconds }}s</span>
                  </template>
                </van-count-down>
                </div>
              <!-- <van-button class="getCode" v-if="!downtime"
              style="padding: 22px;right: 10px;
              top: 8px;border-radius: 10px;"  type="warning"> -->
                <!-- <van-count-down @finish="finish" format="ss" style="font-size:33px;color:#ffffff" :time="times" /> -->
                <!-- </van-button> -->
            </div>
          </div>
          <div class="contentBox4">
            <div class="contentBox-title" style="padding:8px 0 14px 21px">支付方式</div>
            <div style="display:flex;justify-content: space-between;">
              <div class="zfBox">
                <img class="wx" src="../assets/wx.png">
                <div class="payText" style="padding-right:40px">微信支付</div>
                <label class="active" @click.stop="changeRadio()">
                  <input type="radio" name="parent_radio" value="0" v-model="radio"/>
                </label>
              </div>
              <div class="zfBox" v-if="showAlpy" >
                <img class="zfb" src="../assets/zfb.png">
                <div class="payText">支付宝支付</div>
                <label @click.stop="changeRadio()">
                  <input type="radio" name="parent_radio" value="1" v-model="radio"/>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;justify-content: space-between;">
          <div class="price">
            <span>￥</span><span style="font-size:70px;font-weight:700">{{this.content.price}}</span>
          </div>
          <div class="purchase">
            <div class="rushPurchase" @click.stop="toPay">立即抢购</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialogBox" style="display:flex;justify-content:center;align-items:center;" v-if="closeVisible" @touchmove.prevent>
      <div class="exit">
        <!-- <div style="font-size: 40px;color: #FF3700;line-height: 24px;margin: 53px 0px 118px 0;text-align:center;">您确定要放弃吗？</div>
        <div 
          style="line-height: 40px;
          text-align: center;
          font-size: 30px;
          color: rgb(255, 55, 0);
          opacity: 0.9;
          padding-bottom: 51px;
          border-bottom: 1px solid rgb(255, 55, 0);">{{this.content.price}}元 {{this.content.price==899?'365':this.content.price==99?'30':'5'}}天体验期</div> -->
        <div class="exitText">
          <div><span>A I  纠 错</span><span>消灭错音</span></div>
          <div><span>弹奏打分</span>提升兴趣<span></span></div>
          <div><span>海量曲谱</span><span>任由选择</span></div>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <div class="refuse" @click="refuse">残忍拒绝</div>
          <div class="continue" @click="continuePay">立即领取</div>
        </div>
      </div>
    </div>
    
    <van-overlay :show="show" >
      <div  class="wrapper">
       <van-loading size="68px" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'Qs'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
    return{
      dialogVisible:false,
      closeVisible:false,
      house:'00',
      min:'10',
      send:'00',
      timer:null,
      radio:0,
      content:{},
      weChatParameter:null,
      phone: '',//陪练账号
      code: '',//验证码
      downtime:true,
      times:60000,
      timeData:{
        hours:0,
        minutes:3,
        seconds :60000
      },
      openId:null,
      show:false,
      showAlpy:true,
      scrollTop: 0
    }
  },
  mounted(){
    // this.getList()
    // let ua = window.navigator.userAgent.toLowerCase();
    // let isWeixin = ua.indexOf('micromessenger') != -1;
    // if (isWeixin) {  //判断当前环境是否是微信浏览器
    //     this.getCodeWx();
    //     this.showAlpy=false;
    // }else{
    //   this.showAlpy=true;
    // }
  },
  activated () {
    console.log('实例被激活时使用，用于重复激活一个实例的时候')
    this.getList()
    let ua = window.navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf('micromessenger') != -1;
    if (isWeixin) {  //判断当前环境是否是微信浏览器
        this.getCodeWx();
        this.showAlpy=false;
    }else{
      this.showAlpy=true;
    }
  },
  methods: {
    //自动获取验证码
    // changeInput(){
    //   if(this.phone.length==11){
    //     this.phoneReg(this.phone)
    //   }
    // },
    countdownFun() {
        let [h,m,s] = [0,10,0];
        clearInterval(this.timeSet)
        this.timeSet = null;
        this.timeSet = setInterval(()=>{
          if(s<=0){
            s = 60;
            if(m<=0){
              m = 60;
              h--;
            }
            m--;
          }
          s--;

          this.house= h < 10 ? '0' + h : h;
          this.min = m < 10 ? '0' + m : m;
          this.send = s < 10 ? '0' + s : s;
          if(h<=0 && m<=0 && s<=0){
            clearInterval(this.timeSet)
            this.$dialog({
              message: '由于您超时未支付，订单已被关闭，请重新下单',
              theme: 'round-button',
              confirmButtonText: '我知道了',
              width: "90%",
              messageAlign: 'center'
            }).then(() => {
              this.refuse()
            });
          }
        },1000)
    },
    handleDialog(){
        this.dialogVisible = true;
        this.countdownFun();
    },
    finish() {
      this.downtime=true;
    },
    //请求订单详情
    getList(){
      this.show=true;
      this.$http({
        url:'http://api.yiguzheng.com.cn/generateOrderInfo',
        method: 'get',
        params:{
          product_id:1
        }
      }).then(res=>{
        this.show=false;
        this.content=res.data.content;
        sessionStorage.setItem('content',JSON.stringify(res.data.content))
        console.log(res.data.content);
      })
    },
    closeDialog(){
      this.closeVisible = true;
    },
    //残忍拒绝
    refuse(){
      this.phone='';
      this.dialogVisible = false
      this.closeVisible = false
      this.downtime=true;
      clearInterval(this.timeSet)
    },
    //我想练琴
    continuePay(){
      this.closeVisible = false
    },
    //手机号码验证
    phoneReg(val){
      let that=this;
      this.show=true;
      that.downtime=true;
      const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if(!reg.test(val)){
        this.$toast({
          message:'手机号码不正确，请重新输入',
          position: 'middle'  
        })
        this.show=false;
      }else{
         this.$http({
          url:'http://api.yiguzheng.com.cn/isHasOnePurchaseProduct',
          method: 'post',
          data:{
            telephone:that.phone
          }
        }).then(res=>{
           this.show=false;
          if(res.data.code!=0){
            that.$toast({
              message: '体验服务只能购买一次'
            })
          }else{
            that.SendSms();
          }
        })
      }
    },
    //发送验证码
    SendSms(){
      let that=this;
      //发送验证码
        this.$http({
          url:'https://api.yiguzheng.com.cn/SendSMS',
          method: 'post',
          data:{
            telephone:that.phone,
            send_type:"landingpage"
          }
        }).then(res=>{
          if(res.data.code!=0){
            this.$toast({
              message: res.data.message
            })
          }else{
             that.downtime=false;
          }
        })
    },
    //获取验证码
    getCode(){
      if(this.phone == ''){
        this.$toast({
          message: '请输入手机号',
          position: 'middle' 
        })
      }else{
        this.phoneReg(this.phone)
      }
    },
    //立即购买
    toPay(){
      const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if(this.phone == ''){
        this.$toast({
          message: '请输入手机号',
          position: 'middle' 
        })
      }else if(!reg.test(this.phone)){
        this.$toast({
          message:'手机号码不正确，请重新输入',
          position: 'middle'  
        })
      }else if(this.code == ''){
        this.$toast({
          message: '请输入验证码',
          position: 'middle' 
        })
      }else{
        this.show=true;
        this.$http({
          url:'https://api.yiguzheng.com.cn/VerificationSMS',
          method: 'post',
          data:{
            telephone:this.phone,
            verification_code:this.code
          }
        }).then(res=>{
          this.show=false;
            if(res.data.code==0){
              this.content.radio=this.radio;
              this.content.phone=this.phone;
              this.content.openId=this.openId;
              if (this.radio == '1') {
              //支付宝支付
                // this.alipyPayFn();
              this.$router.push({name:"pay",params:{obj:this.content}})
            } else if (this.radio == '0') {
              //微信支付，这里跳转到本文的微信支付模块的3.步骤handelPay方法
              this.$router.push({name:"pay",params:{obj:this.content}})
              // this.wxPayFn();
            }
          }else{
            this.$toast({
              message: '验证码输入不正确',
              position: 'middle' 
            })
          }
        })
      }
    },
    //切换支付方式
    changeRadio(){
      var radio = document.getElementsByName("parent_radio");
      var radioLength = radio.length;
      for(var i = 0;i < radioLength;i++){
        if(radio[i].checked){
          radio[i].parentNode.setAttribute('class', 'active');
        }else {
          radio[i].parentNode.setAttribute('class', '');
        }
      }
    },
     getCodeWx() {
      let obj={
        url:'http://landingpage.yiguzheng.com.cn/index.html'
      };
        let wx_code = this.getUrlParam("code"); // 截取url中的code
        //判断有没有code
        if (!wx_code) {
          //获取code的地址。获取成功重定向后地址栏中将会带有code，判断没有code的话，就跳转到微信官方链接上获取，获取成功后会再重定向回来，注意url是需要使用encodeURIComponent处理一下编码的
          this.$http({
          url:'https://api.yiguzheng.com.cn/oauthUrl',
          method: 'post',
          data:qs.stringify(obj)
        }).then(res=>{
          window.location.href=res.data.content;
        }).catch(err=>{
          console.log(err)
        })
        } else {
            // 获取到了code
            this.getOpenId(wx_code); //把code传给后台获取用户信息
        }
    },
    //getUrlParam方法就是使用正则截取地址栏里的code，有兴趣可以研究一下，没兴趣直接拿来用
    getUrlParam: function (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);//解码
      return null;
    },
    getOpenId(data){
        let obj={
          code:data
        }
        this.$http({
            url:'https://api.yiguzheng.com.cn/getWechatOpenId',
            method: 'post',
            data:qs.stringify(obj)
          }).then(res=>{
            this.openId=res.data.content.openid;
          }).catch(err=>{
            console.log(err)
          })
    },
    focus() {
      this.$nextTick(()=>{
        document.activeElement.scrollIntoView(false)
      })
      document.documentElement.style.position = 'fixed'
    },
    changeBlur(){
      // document.scrollingElement.scrollTo(0, this.scrollTop);
      document.documentElement.style.position = ''
    }
  }
}
</script>
<style scoped>
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  /* .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  } */
.block{
    font-size: 32px;
    font-weight: 400;
    color: #FF3700;
    position: absolute;
    right: 21px;
    top: 8px;
    font-family: SourceHanSansSC-Regular;

}
.hello{
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 14px;
}
img{
  display: block;
}
.ad{
  width: 100%;
  display: block;
}
.box_1 {
  position: fixed;
  bottom: 0;
  display: flex;
  left: 0;
  height: 208px;
  background: url("../assets/enter.png") 0px 0px no-repeat;
  background-size: 750px 208px;
  width: 750px;
}
.text-wrapper_1 {
  width: 190px;
  height: 83px;
  font-size: 110px;
  font-weight: bold;
  font-style: italic;
  color: #FFF43C;
  line-height: 46px;
  text-shadow: 0px 6px 6px rgba(232,35,34,0.3);
  display: flex;
}

.text_1 {
  font-size: 110px;
  line-height: 83px;
}

.text_2 {
  font-size: 42px;
  line-height: 118px;
}

.tag_1 {
  height: 45px;
  background: url("../assets/enterBack.png") 100% no-repeat;
  background-size: 100% 100%;
  width: 211px;
  margin-top: 7px;
  text-align: center;
}

.text_3 {
  font-size: 30px;
  font-weight: 700;
  color: #F1293C;
  line-height: 45px;
  font-family: SourceHanSansSC-Medium;
}
.goBack{
  height: 124px;
  background: url("../assets/goBack.png") no-repeat;
  background-size: 100% 100%;
  width: 118px;
  margin: 66px 51px 0 60px;
}
.text-group_2 {
  width: 83px;
  height: 72px;
  padding: 26px 0 0 16px;
}
.go{
  font-size: 55px;
  font-weight: 400;
  color: #F1293C;
  padding: 26px 0 0 16px;
  line-height: 43px;
}
.gojiantou{
  text-align: center;
  overflow-wrap: break-word;
  color: #F1293C;
  font-size: 28px;
  white-space: nowrap;
  font-weight: 400;
  line-height: 18px;
  padding-top: 11px;
}
.dialogBox{
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background:RGBA(0, 0, 0, 0.8);
}
.payBox{
  overflow: scroll;
  width: 100%;
  height: 774px;;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url("../assets/payBack.png") no-repeat;
  background-size: 750px 774px;
}
.content{
  border-bottom: 1px dashed #DFE3EB;padding: 0px 50px;
}
.close{
  display:flex;justify-content:flex-end;padding-top:20px
}
.contentBox1{
  display:flex;padding:15px 17px 23px 150px;
  border-bottom: 1px dashed;
}
.contentBox1>img{
  width:178px;height:29px;padding-right:17px
}
.contentBox1>b{
  color:#FF3700;font-size:22px;line-height:29px;padding:0 3px
}
.contentBox2{
  padding-top: 21px;
}
.contentBox-title{
  height: 30px;
  line-height: 30px;
  font-size: 30px;
  font-weight: 500;
  color: #333333; 
  padding: 0 0 14px 21px;
  font-family: SourceHanSansSC-Medium;
}
.contentBox2-body{
  width: 650px;
  height: 120px;
  background: url("../assets/orderContentBack.png") 100% no-repeat;
  background-size: 100% 100%;
  padding: 22px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  color: #FFFFFF;
  font-size: 34px;
}
.getCode{
  font-size: 24px;
  font-weight: 400;
  color: #FF3700;
  position:absolute;
  right:21px;
  top:14px;
  font-family: SourceHanSansSC-Regular;
}
.x{
  width:32px;height:33px
}
.time{
  width: 38px;
  height: 34px;
  background: #FF3700;
  border-radius: 6px;
  color:#fff;
  text-align: center;
  font-size: 22px;
  line-height: 34px;
  font-weight: 700;
}
.zfBox{
  display: flex;
  background: url("../assets/payInput.png") no-repeat;
  background-size: 280px 60px;
  align-items: center;
  width: 280px;
  height: 60px;
  line-height: 30px;
  box-sizing: border-box;
  margin-bottom: 28px;
  padding-left: 22px;
}
.wx{
  width:41px;height:33px;
}
.payText{
  font-size: 30px;
  font-weight: 400;
  color: #333333;
  padding: 0 15px 0 10px;
  font-family: SourceHanSansSC-Regular;
}
.zfb{
  width:36px;height:36px;
}
.price{
  font-weight: 500;
  color: #FF3700;
  padding-left:50px;
  font-size: 30px;
}
.rushPurchase{
  font-size: 30px;
  color: #FFFFFF;
  text-align: center;
  line-height: 61px;
  font-family: SourceHanSansSC-Bold;
}
.input{
		-web-kit-appearance:none;
		-moz-appearance: none;
    height: 60px;
		color:#6a6f77;
		outline:0;
    width: 100%;
    border: none;
    text-align: left;
    padding-left: 22px;
    border: 1px solid #FF3700;
    border-radius: 10px;
    box-sizing: border-box;
    margin-bottom:15px;
    /* background: url("../assets/inputBack.png") no-repeat; */
    /* background-size: 650px 60px; */
    font-size: 23px;
    font-family: SourceHanSansSC-Regular;
	}
  .purchase{
    background: url("../assets/purchaseBack.png") no-repeat;
    background-size: 230px 61px;
    width: 230px;
    height: 61px; 
    margin: 21px 50px 0 0;
  }
  .giveUp{
    width: 500px;
    height: 414px;
    background: url("../assets/giveUp.png") 100% no-repeat;
    background-size: 100% 100%;
    font-family: SourceHanSansSC-Medium;
  }
  .refuse{
    width: 210px;
    height: 58px;
    background: url("../assets/refuseBack.png") 100% no-repeat;
    background-size: 100% 100%;
    margin: 48px 0 0 144px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: 500;
    color: #FF3700;
  }
  .continue{
    background: url("../assets/continueBack.png") no-repeat;
    background-size: 100% 100%;
    width: 210px;
    height: 58px;
    margin: 48px 144px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;
  }
  .exit{
    width: 750px;
    height: 568px;
    background: url("../assets/exit.png") 100% no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .exitText{
    box-sizing: border-box;
    padding: 275px 0 0 269px;
    font-size: 26px;
    font-family: SourceHanSansSC-Regular;
    font-weight: 400;
    color: #FF3700;
    line-height: 40px;
    opacity: 0.9;
  }
  .exitText span{
    margin:0 11px 15px 0
  }
  label{
    background: url("../assets/whiteRadio.png") no-repeat;
    background-size: 31px 31px;
    width: 31px;
    height: 31px;
  }
  label.active{
    background: url("../assets/redRadio.png") no-repeat;
    background-size: 30px 30px;
    width: 30px;
    height: 30px;
  }
  input[type=radio]{
    color:gray;
    display: none;
  }
  input:-webkit-autofill, 
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active { 
      -webkit-transition-delay: 99999s;
      -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
  }
  .van-toast{
    font-size: 25px !important;
    border-radius: 15px !important;
    line-height: 25px;
  }
  .van-toast--html, .van-toast--text {
    padding: 20px 44px !important;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue